"use client";

import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { type FC } from "react";
import { useState } from "react";

import { MobileMenu } from "~/components/AppBar/MobileMenu";

export const MobileMenuButton: FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerToggle}
      >
        <MenuIcon />
      </IconButton>
      <MobileMenu open={mobileOpen} onClose={handleDrawerToggle} />
    </>
  );
};
